import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  CPanel,
  CRow,
  CCol,
  CDropDown,
  Text
} from "@appcues/component-library";
import styled from "styled-components";

import { EVENT_SOURCES } from "components/Events/constants";
import { getThemeFor } from "utils";

import EmptyState from "./Common/EmptyState";
import EventSearchBar from "./EventSearchBar";
import Flow from "./Flow";
import Checklist from "./Checklist";
import Builder from "./Builder";
import Application from "./Application";

const StyledCDropDown = styled(CDropDown)`
  text-transform: capitalize;
`;

const PanelBanner = styled.div`
  display: flex;
  padding: 10px;
  text-align: center;
  margin-top: 20px;
  margin-left: -25px;
  margin-right: -25px;
  margin-bottom: 25px;
  border-bottom: 1px solid ${getThemeFor("$gray-2")};
  border-top: 1px solid ${getThemeFor("$gray-2")};
  background-color: ${getThemeFor("$gray-1")};
  justify-content: center;
`;

export const Sources = ({
  startTime,
  segmentId,
  selectedEvents,
  onSelectEvent,
  hasEvents = true
}) => {
  const [eventSource, setEventSource] = useState(EVENT_SOURCES[0]);
  const [searchTerm, setSearchTerm] = useState("");

  const eventSourceOptions = EVENT_SOURCES.map(source => ({
    value: source,
    label: `${source} Events`
  }));

  if (!hasEvents) {
    return <EmptyState />;
  }

  const sourceProps = {
    startTime,
    segmentId,
    searchTerm,
    selectedEvents,
    enableSelect: selectedEvents && selectedEvents.length < 4,
    onSelect: onSelectEvent
  };

  return (
    <CPanel title="Event Source">
      <CRow between="xs">
        <CCol xs={3}>
          <StyledCDropDown
            options={eventSourceOptions}
            value={eventSource}
            onChange={setEventSource}
          />
        </CCol>
        <CCol xs={3}>
          <EventSearchBar
            placeholder={`Search ${eventSource} Events`}
            onChange={setSearchTerm}
          />
        </CCol>
      </CRow>
      <PanelBanner>
        <Text>Compare events by selecting them below. Maximum 4.</Text>
      </PanelBanner>
      {eventSource === "application" && <Application {...sourceProps} />}
      {eventSource === "builder" && <Builder {...sourceProps} />}
      {eventSource === "checklist" && <Checklist {...sourceProps} />}
      {eventSource === "flow" && <Flow {...sourceProps} />}
    </CPanel>
  );
};

Sources.propTypes = {
  hasEvents: PropTypes.bool,
  startTime: PropTypes.string,
  segmentId: PropTypes.string,
  selectedEvents: PropTypes.arrayOf(
    PropTypes.shape({
      source: PropTypes.string,
      event: PropTypes.string
    })
  ),
  onSelectEvent: PropTypes.func
};

export default Sources;
